import ko from "knockout";
import template from "./app.template.html";
import viewModel from "./app.viewmodel.js";
import "../components/page";
import "../components/index";
import "../components/gallery";
import "../components/glossary";
import "../components/modal";
import "../components/pop-up";
import "../components/storyline";
import "../components/start";
import "../components/introduction";
import "../components/views";
import "../components/snackbar";
import "../components/search";

ko.components.register("app", { template, viewModel });
